import React from 'react';
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core';
import { useTranslation } from 'react-i18next';
import { SEARCH_RESULTS } from '../../../i18n/keyConstants';

const TableHeader = ({ children, tableSize }) => {
    const { t } = useTranslation(['shared']);
    return (
        <Plugin>
            <Template name='header'>
                <div className='card-header py-2 d-flex position-relative dx-g-bs4-toolbar'>
                    <div className='tableSize padding-top-10px padding-bottom-10px c-black'>
                        <span>{t(SEARCH_RESULTS)} {tableSize}</span>
                    </div>
                    <div className='d-flex ml-auto my-auto'>{children}</div>
                </div>
                <TemplatePlaceholder />
            </Template>
        </Plugin>
    );
};

export default TableHeader;

